export default "__VITE_ASSET__4d9418e6__"